import { render, staticRenderFns } from "./association-occasions.vue?vue&type=template&id=5b5b0432&scoped=true"
import script from "./association-occasions.vue?vue&type=script&lang=ts"
export * from "./association-occasions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b0432",
  null
  
)

export default component.exports